import {
  Toggle,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';
import CodeIcon from '@/shared/ui/Icons/CodeIcon';
import type { ToggleViewSwitchProps } from './ToggleViewSwitch.types';

export function ToggleViewSwitch({ showCodeView, onChange }: ToggleViewSwitchProps) {
  const { t } = useTranslation('common');

  const target = showCodeView
    ? t('components.toggleViewSwitch.emailView')
    : t('components.toggleViewSwitch.html');
  const label = t('components.toggleViewSwitch.switchTo', { target });

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Toggle
            variant="outline"
            pressed={showCodeView}
            onPressedChange={onChange}
            aria-label={label}
          >
            <CodeIcon />
          </Toggle>
        </TooltipTrigger>
        <TooltipContent side="bottom">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
